import { render, staticRenderFns } from "./FreeTextFormItem.vue?vue&type=template&id=6fe0a7d7&scoped=true&"
import script from "./FreeTextFormItem.vue?vue&type=script&lang=js&"
export * from "./FreeTextFormItem.vue?vue&type=script&lang=js&"
import style0 from "./FreeTextFormItem.vue?vue&type=style&index=0&id=6fe0a7d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe0a7d7",
  null
  
)

export default component.exports